import { TagInputComponent } from '../../components/tag-input/tag-input';
import { TagModel } from '../accessor';

import { Injectable } from '@angular/core';

export declare interface DraggedTag {
    index: number;
    tag: TagModel;
    zone: string;
}

import { DRAG_AND_DROP_KEY } from '../../core/constants';

export declare interface State {
    dragging: boolean,
    dropping: boolean,
    index: number | undefined
}

export declare type StateProperty = keyof State;
export class DragProvider {
public sender: TagInputComponent;
public receiver: TagInputComponent;
public state: State = {
        dragging: false,
        dropping: false,
        index: undefined
    };
/**
 * \@name setDraggedItem
 * @param {?} event
 * @param {?} tag
 * @return {?}
 */
public setDraggedItem(event: DragEvent, tag: DraggedTag): void {
        event.dataTransfer.setData(DRAG_AND_DROP_KEY, JSON.stringify(tag));
    }
/**
 * \@name getDraggedItem
 * @param {?} event
 * @return {?}
 */
public getDraggedItem(event: DragEvent): DraggedTag {
        const /** @type {?} */ data = event.dataTransfer.getData(DRAG_AND_DROP_KEY);

        return /** @type {?} */(( JSON.parse(data) as DraggedTag));
    }
/**
 * \@name setSender
 * @param {?} sender
 * @return {?}
 */
public setSender(sender: TagInputComponent): void {
        this.sender = sender;
    }
/**
 * \@name setReceiver
 * @param {?} receiver
 * @return {?}
 */
public setReceiver(receiver: TagInputComponent): void {
        this.receiver = receiver;
    }
/**
 * \@name onTagDropped
 * @param {?} tag
 * @param {?} indexDragged
 * @param {?} indexDropped
 * @return {?}
 */
public onTagDropped(tag: TagModel, indexDragged: number, indexDropped: number): void {
        this.onDragEnd();

        this.sender.onRemoveRequested(tag, indexDragged);
        this.receiver.onAddingRequested(false, tag, indexDropped);
    }
/**
 * \@name setState
 * @param {?} state
 * @return {?}
 */
public setState(state: {[K in StateProperty]?: State[K]}): void {
        this.state = {...this.state, ...state};
    }
/**
 * \@name getState
 * @param {?=} key
 * @return {?}
 */
public getState(key?: StateProperty): State | State[StateProperty] {
        return key ? this.state[key] : this.state;
    }
/**
 * \@name onDragEnd
 * @return {?}
 */
public onDragEnd(): void {
        this.setState({
            dragging: false,
            dropping: false,
            index: undefined
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DragProvider_tsickle_Closure_declarations() {
/** @type {?} */
DragProvider.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragProvider.ctorParameters;
/** @type {?} */
DragProvider.prototype.sender;
/** @type {?} */
DragProvider.prototype.receiver;
/** @type {?} */
DragProvider.prototype.state;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
